<template>
  <div class="login-content w-full grow justify-center flex h-[100vh]">
    <div class="items-center">
      <div class="content-right relative justify-center flex-1 flex-y-center flex-col">
        <div class="operation-wrap">
          <FormFeishu />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FormFeishu from './form-feishu.vue';

// 飞书支持
useHead({
  meta: [
    {
      name: 'hideMenuItems',
      content: 'openInBrowser',
      'lk-config': '',
    },
    {
      name: 'hideMenuItems',
      content: 'copyLink', // 仅禁用复制链接
    },
  ],
});
</script>

<style lang="scss" scoped>
.login-content {
  background: var(--login-bg);

  > div {
    @apply flex-1 flex w-full min-h-[640px] max-w-[1586px];
  }

  .content-right {
    .operation-wrap {
      overflow: hidden;
      position: relative;
      padding: 50px 90px 40px;
      width: 600px;
      background: var(--login-operation-bg);
      border-radius: 20px;
      border: 1px solid var(--back-3);
    }
  }
}
</style>
